import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export enum IconType {
  ENVELOPE = 'envelope-icon',
  ALERT = 'alert-icon',
  FILECHECK = 'file-check-icon',
  PAPERPLANE = 'paper-plane',
  LOCK = 'lock-icon',
}

export enum IconClass {
  ENVELOPE = 'fa-solid fa-envelope-open-text',
  ALERT = 'fas fa-chart-line-up',
  FILECHECK = 'fa-solid fa-file-check',
  PAPERPLANE = 'fas fa-paper-plane',
  LOCK = 'fa fa-solid fa-lock',
}
export interface IconProperties {
  height: string;
  width: string;
  padding: string;
  iconSize: string;
  textSize: string;
  color: string;
  bgColor: string;
  hoverColor: string;
  hoverBgColor: string;
  disabledColor: string;
  disabledBgColor: string;
  iconTextBottom: string;
}

export interface IconData {
  type: IconDefinition;
  optionalType?: string; // Remove string after AngularJS Migration
  text?: IconText;
  class: string;
}

export interface IconText {
  inner?: string;
  outer?: string;
}
